var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/x-extension-editor.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-empty-placeholder.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import { XSnackbar } from "@adornis/chemistry/elements/components/x-snackbar.js";
import "@adornis/chemistry/elements/components/x-stack";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/cms/client/generated-form.js";
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import "@adornis/forms/x-checkbox.js";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { combineLatest, map } from "rxjs";
import { PageStatus } from "../../db/enums.js";
import { RenderableConfigFormController } from "../RenderableConfigFormController.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-size-picker.js";
import "../components/x-buildify-spacing-picker.js";
import "../components/x-icon-button.js";
import "../components/x-infobox";
import { ContentConsumer, CustomContentConsumer, ExtensionsConsumer } from "../globals/consumer.js";
import { Size } from "../globals/enums.js";
import { ThrowEventCopyToClipboard, ThrowEventSetContent, ThrowEventSetEditContent } from "../globals/events.js";
import { copyClipboardContent, getExtensionForData } from "../globals/methods.js";
var XExtensionEditor = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.content = new RXController(this, void 0);
    this.parentController = new RXController(
      this,
      void 0
    );
    this._size = new RXController(this, void 0);
    this._controller = new RXController(
      this,
      combineLatest([this.content.observable, this._size.observable, this.parentController.observable]).pipe(
        map(
          ([content, size, controller]) => controller ? controller : new RenderableConfigFormController(this, content, size, {
            error: (instance) => {
              XSnackbar.show("Dieser Inhalt enth\xE4lt noch Fehler!");
            },
            success: (instance) => {
              ThrowEventSetEditContent(this, null);
            }
          })
        )
      )
    );
    this._consumedExtensions = ExtensionsConsumer(this);
    this._consumedContents = ContentConsumer(this);
    this._consumedCustomContent = CustomContentConsumer(this);
  }
  updated(changedProps) {
    super.updated(changedProps);
    if (this._lastController !== this._controller.value) {
      this._lastController?.hostDisconnected();
      this._lastController = this._controller.value;
    }
  }
  render() {
    if (!this.content.value) {
      return xComponents(
        html` <x-empty-placeholder text="Inhalt nicht gefunden" .img=${"close"}></x-empty-placeholder> `
      );
    }
    return xComponents(html`
      <x-flex space="md" ${css({ flex: 1 })}>
        <!-- size picker -->
        <x-flex horizontal crossaxis-center space-between>
          <x-buildify-size-picker
            .value=${this._size.value}
            @value-picked=${(e) => {
      this._size.next(e.detail.value);
    }}
          ></x-buildify-size-picker>
          ${this._extensionName()}
        </x-flex>

        <x-hr></x-hr>

        <x-stack> ${this._content()} </x-stack>

        <x-hr></x-hr>
        <x-buildify-default-editor
          .content=${this.content.value}
          .parentController=${this._controller.value}
        ></x-buildify-default-editor>

        <!-- actions -->
        <x-flex
          space="sm"
          horizontal
          space-between
          crossaxis-center
          ${css({ padding: `${this.spacing.sm} 0`, position: "sticky", bottom: "0", background: "white" })}
        >
          <x-icon-button
            icon=${this.configuration.icons.done}
            @click=${async () => {
      await this._controller.value?.validate();
    }}
            background=${this.colors.accent}
            color=${this.colors.on.accent}
            text="fertig"
          >
          </x-icon-button>
          <x-flex horizontal crossaxis-center space="sm">
            ${this._consumedCustomContent.value ? html`
                  <x-icon-button
                    icon=${this.configuration.icons.contentCopy}
                    color="#333"
                    background="rgb(195, 195, 195)"
                    text="Als Benutzerdefinierte Komponente abspeichern"
                    @click=${async () => {
      const customContentDefinition = this._consumedCustomContent.value;
      if (!customContentDefinition || !this._consumedExtensions.value || !this.content.value)
        return;
      const copiedContent = copyClipboardContent({
        extensions: this._consumedExtensions.value,
        contentID: this.content.value._id,
        content: this._consumedContents.value
      });
      const name = await XNativeDialog.prompt("Wie soll diese Komponente hei\xDFen?");
      if (!name)
        return;
      const customContent = new customContentDefinition.class({
        name,
        content: copiedContent,
        isTemplate: true,
        status: PageStatus.PUBLISHED
      });
      await customContent.create();
      XSnackbar.show("Custom Content erstellt!");
    }}
                  ></x-icon-button>
                ` : nothing}
            <x-icon-button
              icon=${this.configuration.icons.contentCopy}
              color="#333"
              background="rgb(195, 195, 195)"
              text="Zwischenablage"
              @click=${() => {
      ThrowEventCopyToClipboard(this, this.content.value);
      ThrowEventSetEditContent(this, null);
    }}
            ></x-icon-button>
            <x-icon-button
              icon=${this.configuration.icons.delete}
              color="#fff"
              background=${this.colors.tone.error}
              text="Löschen"
              @click=${async () => {
      if (!await XNativeDialog.confirm("Wollen Sie dieses Element wirklich l\xF6schen?"))
        return;
      if (!this.content.value || !this._consumedContents.value)
        return;
      this._removeContent(this.content.value._id);
      ThrowEventSetContent(this, this._consumedContents.value);
      ThrowEventSetEditContent(this, null);
    }}
            ></x-icon-button>
          </x-flex>
        </x-flex>
      </x-flex>
    `);
  }
  get configuration() {
    return {
      icons: {
        delete: "delete",
        contentCopy: "content_copy",
        done: "check"
      }
    };
  }
  _extensionName() {
    const controller = this._controller.value;
    const document = controller?.document;
    if (!controller || !document)
      throw new Error("404 - No document found");
    const extension = getExtensionForData(document, this._consumedExtensions.value ?? []);
    return html` <x-h3> ${extension.toolbar?.text.default} </x-h3> `;
  }
  _content() {
    const controller = this._controller.value;
    const document = controller?.document;
    if (!controller || !document)
      throw new Error("404 - No document found");
    const extension = getExtensionForData(document, this._consumedExtensions.value ?? []);
    const extensionEditor = extension.editor?.({
      content: document,
      // @ts-ignore
      contentController: controller,
      controllerBaseKeyPath: [],
      // @ts-ignore
      host: this
    });
    return xComponents(
      extensionEditor ? extensionEditor : html`
            <generated-form
              .formController=${controller}
              .placeholderMode=${"inline-floating"}
              .blacklist=${["index", "parentID", "configs", "subItemID", ...Object.values(Size)]}
            ></generated-form>
          `
    );
  }
  _defaultEditor() {
    const controller = this._controller.value;
    const document = controller?.document;
    if (!controller || !document)
      throw new Error("404 - No document found");
    const extension = getExtensionForData(document, this._consumedExtensions.value ?? []);
    if (extension.showDefaultEditor === void 0 || extension.showDefaultEditor)
      return html`
        <x-hr></x-hr>
        <x-buildify-default-editor .content=${this.content.value} .parentController=${this._controller.value}>
        </x-buildify-default-editor>
      `;
    else
      return html`<div ${css({ height: "100%" })}></div>`;
  }
  _removeContent(contentID) {
    if (!this._consumedContents.value)
      return;
    const index = this._consumedContents.value.findIndex((base) => {
      return base._id === contentID;
    });
    if (index !== -1) {
      this._consumedContents.value.splice(index, 1);
      const children = this._consumedContents.value.filter((item) => item.parentID === contentID);
      for (const child of children) {
        this._removeContent(child._id);
      }
    }
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": { display: "flex", flexDirection: "column", height: "100%" },
        "[size-picker]>*": {
          cursor: "pointer",
          padding: this.spacing.xs,
          borderRadius: this.sizes.borderRadius,
          fontSize: "18px",
          background: "#C3C3C3",
          color: "#fff"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XExtensionEditor.prototype, "content", 2);
__decorateClass([
  property({ attribute: false })
], XExtensionEditor.prototype, "parentController", 2);
__decorateClass([
  state()
], XExtensionEditor.prototype, "_size", 2);
__decorateClass([
  state()
], XExtensionEditor.prototype, "_controller", 2);
XExtensionEditor = __decorateClass([
  customElement("x-extension-editor")
], XExtensionEditor);
var XBuildifyDefaultEditor = class extends XExtensionEditor {
  render() {
    const controller = this._controller.value;
    if (!controller)
      return nothing;
    return xComponents(html`
      <x-flex space="sm">
        <x-buildify-spacing-picker
          select
          clearable
          placeholder="Innenabstand"
          ${controller.field("padding")}
        ></x-buildify-spacing-picker>
        <x-buildify-spacing-picker
          select
          clearable
          placeholder="Außenabstand"
          ${controller.field("margin")}
        ></x-buildify-spacing-picker>
        <x-buildify-permission-selection ${controller.field("permission")}></x-buildify-permission-selection>
        <x-infobox>
          Wenn du zu anderen Elementen verlinken möchtes, kannst du hier (Zielelement) eine ID festlegen und woanders
          über die Syntax '#ID' verlinken. Diese Art der Verlinkungen sind nur innerhalb einer Seite möglich!
        </x-infobox>
        <x-dropdown-selection
          placeholder="Anzeige"
          clearable
          ${controller.field("display")}
          .selectables=${["none"]}
          .renderString=${(key) => (() => {
      switch (key) {
        case "none":
          return "Ausblenden";
      }
    })()}
        ></x-dropdown-selection>
        <x-input placeholder="HTML-ID" ${controller.field("htmlID")}></x-input>
      </x-flex>
    `);
  }
};
XBuildifyDefaultEditor = __decorateClass([
  customElement("x-buildify-default-editor")
], XBuildifyDefaultEditor);
export {
  XBuildifyDefaultEditor,
  XExtensionEditor
};
